import produce from 'immer';

import { ReducerAction } from 'store/modules/types';

import { Types, PCOV } from './types';

export const INITIAL_STATE: PCOV = {
	status: 0,
	mensagem: '',
	data: {
		codigoRetorno: '',
		tipoCliente: 0,
		chassi: '',
		renavam: '',
		qtdeCv: 0,
		lstCv: [
			{
				statusCV: {
					codigo: '',
					descricao: '',
				},
				placa: '',
				nomeComprador: '',
				tipoDocumentoComprador: {
					codigo: '',
					descricao: '',
				},
				cpfCnpjComprador: '',
				dataVenda: '',
				origemCV: {
					codigo: '',
					descricao: '',
				},
				usuario: '',
			},
		],
	},
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): PCOV {
	return produce(state, draft => {
		switch (action.type) {
			case Types.PCOV_REQUEST: {
				break;
			}

			case Types.PCOV_SUCCESS: {
				draft.status = action.payload.status;

				draft.data = action.payload.data;

				break;
			}

			case Types.PCOV_FAILURE: {
				const { status, data, message } = action.payload;

				draft.status = status || data.status;

				draft.data = data;

				draft.mensagem = `${data.data.codigo} - ${message}`;

				break;
			}

			case Types.PCOV_CLEAR: {
				draft.status = 0;

				draft.data = INITIAL_STATE.data;

				break;
			}

			default:
		}

		return draft;
	});
}
